import {app} from '../../app';

app.service('ShowNoteModal', modal);

/** @ngInject */
function modal($uibModal) {

    return (title, note) => {
        return $uibModal.open({
            component: 'showNote',
            resolve: {
                title: () => title,
                note: () => note,
            }
        }).result;
    };
    
}



// WEBPACK FOOTER //
// ./src/portal/components/show-note/show-note.modal.js